import React, { createRef } from "react";
import { connect } from "react-redux";
import { fetchUsers, toggleAccess, editScopes } from "../../actions/usersActions";
import { convertDateTimeToDate } from "../helpers/dateFormat";
import convertBooleanToYesNo from "../helpers/boolFormat";

import Table from '../helpers/Table';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EditIcon from '@mui/icons-material/Edit';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import UserScopesForm from "./UserScopesForm";
import ModalElement from "../Modal";
import history from "../../history";

const columns = [
    { id: 'name', label: 'Name', minWidth: 170, action: false },
    { id: 'email', label: 'Email', minWidth: 100, action: false },
    {
        id: 'verified',
        label: 'Email verified',
        minWidth: 100,
        format: (value) => convertBooleanToYesNo(Boolean(value)),
        action: false
    },
    { id: 'customer', label: 'Customer', minWidth: 100, action: false },
    {
        id: 'created_at',
        label: 'Created at',
        minWidth: 100,
        // align: 'right',
        format: (value) => convertDateTimeToDate(value.toLocaleString('en-US')),
        action: false
    },
    { id: 'has_access', label: 'Access', minWidth: 100, action: true },
    { id: 'scopes', label: 'Scopes', minWidth: 100, action: false },
];


class UsersAdmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAccess: false,
            scopesInputOpen: false,
            editScopesUserId: null
        };

        // Create a ref for Formik
        this.formikRef = createRef();
    }

    handleClose = () => {
        this.setState({ scopesInputOpen: false })
    }

    componentDidMount() {
        if (!this.props.isRefreshing) {
            this.props.fetchUsers();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isRefreshing !== prevProps.isRefreshing) {
            this.props.fetchUsers();
        }
    }

    createData = (id, firstname, lastname, email, customer, created_at, verified, has_access, scopes) => {
        const name = firstname + ' ' + lastname;
        return { id, name, email, customer, created_at, verified, has_access, scopes };
    }

    editScopes = (id) => {
        this.setState({ editScopesUserId: id })
        this.setState({ scopesInputOpen: true })
    }

    editScopesAction = (id) => {
        return (
            <React.Fragment>
                <IconButton size="small" onClick={() => this.editScopes(id)}>
                    <EditIcon />
                </IconButton>
            </React.Fragment>
        )
    }

    scopesFormActions = () => {
        return (
            <React.Fragment>
                <Button variant="contained" startIcon={<EditIcon />} size="small" type="submit" sx={{ mt: 2 }}>Save</Button>
            </React.Fragment>
        )
    }

    onSubmitScopes = (values) => {
        values.id = this.state.editScopesUserId;
        this.props.editScopes(values);
        this.handleClose();
    };

    renderScopesInput = (id) => {
        return (
            <ModalElement
                modalOpen={this.state.scopesInputOpen}
                modalWidth={400}
                handleClose={this.handleClose}
                header="Edit Scopes"
                instruction=""
                content={
                    <UserScopesForm
                        scopes={this.props.users.find(user => user.id === id)?.scopes || []}
                        formActions={this.scopesFormActions}
                        onSubmit={this.onSubmitScopes}
                        ref={this.formikRef}
                    />
                }
            />
        )
    }

    render() {
        const userRows = this.props.users.map((user) => {
            return (
                this.createData(user.id, user.firstname, user.lastname, user.email, user.businessname, user.created_at, user.verified, user.has_access, this.editScopesAction(user.id))
            )
        })

        return (
            <Box
            // sx={{
            //     marginTop: 8,
            //     display: 'flex',
            //     flexDirection: 'column',
            //     alignItems: 'left',
            //     maxWidth: 1000,
            //     ml: 5
            // }}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    {/* Left Section with Icon and Title */}
                    <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3 }}>
                        <ManageAccountsIcon />
                        <Typography variant="h6">User Admin</Typography>
                    </Stack>

                    {/* Positioned Button */}
                    <Button variant="contained" startIcon={<ArrowBackIosIcon />} onClick={() => history.push('/')} sx={{ mr: '30%', mt: 3, textTransform: 'none' }}>
                        Back
                    </Button>
                </Stack>
                <Box sx={{ maxWidth: 1000, ml: 5, mt: 5 }}>
                    <Table
                        columns={columns}
                        rows={userRows}
                        action={this.props.toggleAccess}
                    />
                </Box>
                {this.renderScopesInput(this.state.editScopesUserId)}
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isRefreshing: state.auth.isRefreshing,
        users: Object.values(state.users)
    }
}

export default connect(mapStateToProps, { fetchUsers, toggleAccess, editScopes })(UsersAdmin)